import IApiResponse from '../interfaces/IApiResponse';
import IApiMessage from '../interfaces/IApiMessage';

const FailedApiMessage: IApiMessage = {
    UserMessage: "Failed",
    ServerMessage: "Failed Server Message",
}

const FailedApiResponse: IApiResponse<any> = {
    Data: {},
    Success: false,
    Message: FailedApiMessage,
}

export default FailedApiResponse;